import { GlobalApiResponse } from "app/core/models/apiResponse.interface";

export class ActionGetFrequentOrderItem {
  static readonly type = "[FREQUENT ITEM] GET FREQUENT ITEMS";
  constructor(public payload: GlobalApiResponse) {}
}
